"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_PROVIDER_REQUEST_STATUS_CODES = exports.ProviderRequestStatus = void 0;
var ProviderRequestStatus;
(function (ProviderRequestStatus) {
    ProviderRequestStatus[ProviderRequestStatus["Pending"] = 10] = "Pending";
    ProviderRequestStatus[ProviderRequestStatus["Accepted"] = 20] = "Accepted";
    ProviderRequestStatus[ProviderRequestStatus["Rejected"] = 30] = "Rejected";
    ProviderRequestStatus[ProviderRequestStatus["Timeout"] = 31] = "Timeout";
    ProviderRequestStatus[ProviderRequestStatus["ConsumerCancelled"] = 40] = "ConsumerCancelled";
    ProviderRequestStatus[ProviderRequestStatus["ConsumerAccepted"] = 50] = "ConsumerAccepted";
    ProviderRequestStatus[ProviderRequestStatus["ConsumerAcceptedOther"] = 51] = "ConsumerAcceptedOther";
    ProviderRequestStatus[ProviderRequestStatus["ConsumerRejected"] = 60] = "ConsumerRejected";
})(ProviderRequestStatus = exports.ProviderRequestStatus || (exports.ProviderRequestStatus = {}));
exports.ACTIVE_PROVIDER_REQUEST_STATUS_CODES = [
    ProviderRequestStatus.Pending,
    ProviderRequestStatus.Accepted,
];
